// HEADER
var outletHeader = (function () {
    var headerSearch = document.querySelectorAll(".headerSearch"); // need to return a nodelist to work
    var menuBar = document.querySelectorAll(".menuContain");
    var outletLogo = document.querySelector(".headerLogoSearch").querySelectorAll("a");
    const searchBox = document.getElementById("search");
    const errorMessage = document.getElementById("searchError");

    var escapeHTML = function (str) {
        return str.replace(/[&<>"'?:;=+#%@$^*\(\)\/\\`~!,.\[\]\{\}| ]/g, function (match) {
            return ({
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                "'": '&apos;',
                "?": '&quest;',
                ":": '&colon;',
                ";": '&semi;',
                "=": '&equals;',
                "+": '&plus;',
                "#": '&num;',
                "%": '&percnt;',
                "@": '&commat;',
                "$": '&dollar;',
                "^": '&Hat;',
                "*": '&ast;',
                "(": '&lparen;',
                ")": '&rparen;',
                "/": '&sol;',
                "\\": '&bsol;',
                "`": '&grave;',
                "~": '&tilde;',
                "!": '&excl;',
                ",": '&comma;',
                ".": '&period;',
                "[": '&lsqb;',
                "]": '&rsqb;',
                "{": '&lcub;',
                "}": '&rcub;',
                "|": "&verbar;",
                " ": '_'
            })[match];
        });
    };

    var init = function () {
        if (searchBox) {
            searchBox.addEventListener("keyup", function (e) {
                if (e.key == "Enter") {
                    search(searchBox.value);
                } else if (e.key != 'End' && e.key != 'Home' && e.key != 'ArrowLeft' && e.key != 'ArrowUp' && e.key != 'ArrowRight' && e.key != 'ArrowDown' && e.key != "Escape" && e.key != "CapsLock") {
                    // extreme key code stuff needed to get this to play nice with voiceover/safari
                    errorMessage.classList.add("hide");
                }
            });
            document.getElementById('logo_search').addEventListener("click", function (e) {
                e.preventDefault();
                search(searchBox.value);
            });
        }

        accountHeader.LoadUserLinks();

        if (document.querySelector(".skip")) {
            document.querySelector(".skip").addEventListener("click", skipToMain);
        }

        moveSearchBox();
        window.addEventListener("resize", moveSearchBox);
    };

    var skipToMain = function (e) {
        e.preventDefault();
        var el = e.currentTarget;
        var skipTo = "#" + el.href.split('#')[1];
        document.querySelector(skipTo).setAttribute('tabindex', -1);
        document.querySelector(skipTo).addEventListener('blur', function () {
            this.removeAttribute('tabindex');
        });
        document.querySelector(skipTo).addEventListener('focusout', function () {
            this.removeAttribute('tabindex');
        });
        document.querySelector(skipTo).focus();
    };

    var accountHeader = (function () {
        var accountLink;

        var init = function () {
            accountLink = document.getElementById("accountLink");

            accountLink.addEventListener("click", showHideAccount);
            keyboardEvents();
        };

        var loadUserLinks = function () {
            fetch('/Header/UserSpecificLinks', { headers: { 'X-Requested-With': 'fetch' } }).then(function (response) {
                return (response.ok) ? response.text() : '';
            }).then(function (html) {
                if (html.length < 1) { return; }
                document.getElementById('userLinks').innerHTML = (html);
                init();
            });
        };

        var showHideAccount = function (e) {
            e.preventDefault();
            if (document.getElementById("accountDropDown").classList.contains("hide")) {
                show();
            } else {
                hide();
            }
        };

        var show = function () {
            document.getElementById("accountDropDown").classList.remove("hide");
            accountLink.setAttribute("aria-expanded", "true");
            accountLink.classList.add("active");
            document.addEventListener("keydown", escapeAccount);
            document.addEventListener("click", closeClickOutside);
        };

        var hide = function () {
            document.getElementById("accountDropDown").classList.add("hide");
            accountLink.setAttribute("aria-expanded", "false");
            accountLink.classList.remove("active");
            document.removeEventListener("keydown", escapeAccount);
            document.removeEventListener("click", closeClickOutside);
        };

        var escapeAccount = function (e) {
            if (e.key == "Escape") { // allow user to close on escape
                hide();
                accountLink.focus();
            }
        };

        var closeClickOutside = function (e) {
            var specifiedElement = document.getElementById('headerAccountWrapper');
            var isClickInside = specifiedElement.contains(e.target);

            if (!isClickInside) {
                hide();
            }
        };

        var keyboardEvents = function () {
            var accountLinks = document.getElementById("accountDropDown").querySelectorAll("a");
            var lastLink = accountLinks[accountLinks.length - 1];
            lastLink.addEventListener("keydown", function (e) {
                if (e.key == "Tab") {
                    e.preventDefault();
                    e.stopPropagation();
                    hide();
                    document.getElementById("headerAccountWrapper").nextElementSibling.querySelector("a").focus();
                }
            });
        };

        return {
            Init: init,
            LoadUserLinks: loadUserLinks
        };
    })();

    var search = function(searchby) {
    		// Trim the search term to remove leading and trailing spaces
    		searchby = searchby.trim();
    		errorMessage.classList.add("hide");

    		// Check if the search term is empty
    		if (searchby === "") {
        	// Display error message if the search term is empty
        		errorMessage.classList.remove("hide");
        		searchBox.value = "";  // Clear the search input field
        		return;  // Exit the function early to prevent further processing
    		}

    		// Check if the search term contains any invalid HTML elements or potentially harmful content
    		let doc = new DOMParser().parseFromString(searchby, "text/html");
    		let notHtml = !Array.from(doc.body.childNodes).some(node => node.nodeType === 1);

            if (notHtml)
            {
       		    // Redirect to the search results page with the sanitized search term
        		window.location = "/main/search/" + escapeHTML(searchby);
            } else {
        		// If the search term contains invalid HTML or potentially dangerous content, show an error
        		errorMessage.classList.remove("hide");
        		searchBox.value = "";  // Clear the search input field
    		}
    };

    var moveSearchBox = function () {
        if (window.innerWidth < 600 && !menuBar[0].parentNode.previousElementSibling.classList.contains("headerSearch")) {
            menuBar[0].parentNode.insertBefore(headerSearch[0], menuBar[0]);
        } else if (window.innerWidth >= 600 && !document.querySelector(".headerLogoSearch").querySelector("a").nextElementSibling) {
            outletLogo[0].parentNode.insertBefore(headerSearch[0], outletLogo[0].nextSibling);
        }
    };

    return {
        Init: init
    };
})();

// FOOTER
var outletFooter = (function () {
    var footerAccordions;

    var init = function () {
        footerAccordions = new getAccordions4i();
        footerAccordions.init(document.querySelector("footer"));
        openCloseAccordions();
        window.addEventListener("resize", openCloseAccordions);
    };

    var openCloseAccordions = function () {
        if (window.innerWidth < 600) {
            footerAccordions.close(document.getElementById("quickLinksSection"));
            footerAccordions.close(document.getElementById("mediaSection"));
            footerAccordions.close(document.getElementById("servicesSection"));
        } else {
            footerAccordions.openAll(document.querySelector("footer"));
        }
    };

    return {
        Init: init
    };
})();

(function () {
    outletHeader.Init();

    if (document.getElementById("mediaSection")) {
        outletFooter.Init();
    }
})();